import { NgModule } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { CommonModule } from '@angular/common';
import { HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OrderByPipe } from './services/pipes/order-by.pipe';
import { FilterPipe } from './services/pipes/filter.pipe';
import { KeysPipe } from './services/pipes/keys.pipe';
import { ConvertUnitsPipe } from './services/pipes/convert-units.pipe';
import { StarRatingComponent } from './pages/aeroview/pages/sidebar/pages/monitor/components/monitor-data-window/components/star-rating/star-rating.component';
import { MonthYearValidatorDirective } from './shared/directives/month-year-validator.directive';
import { ChangeLanguageDialogComponent } from './shared/components/change-language-dialog/change-language-dialog.component';
import { TooltipListPipe } from './services/pipes/tooltip-list.pipe';
import { DayMonthYearValidatorDirective } from './shared/directives/day-month-year-validator.directive';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatRippleModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { IconsComponent } from './core/icons/icons.component';
import { NotFoundComponent } from './core/components/not-found/not-found.component';
import { SafePipe } from 'AppServices/pipes/safe.pipe';

// The goal of this module is to remove noise from AppCommonModule
@NgModule({
  exports: [
    MatBadgeModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatStepperModule,
    MatExpansionModule,
    MatGridListModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSnackBarModule,
    MatToolbarModule,
    MatTooltipModule,
    MatChipsModule,
    MatToolbarModule,
    MatFormFieldModule
  ],
  declarations: [],
})
export class AppMaterialModule {}


@NgModule({
  imports: [
    CommonModule,
    AppMaterialModule,
    RouterModule,
    FormsModule
  ],
  declarations: [
    ConvertUnitsPipe,
    OrderByPipe,
    FilterPipe,
    KeysPipe,
    TooltipListPipe,
    SafePipe,
    MonthYearValidatorDirective,
    DayMonthYearValidatorDirective,
    ChangeLanguageDialogComponent,
    StarRatingComponent,
    IconsComponent,
    NotFoundComponent,
  ],
  entryComponents: [
    ChangeLanguageDialogComponent
  ],
  exports: [
    CommonModule,
    AppMaterialModule,
    HttpClientModule,
    HttpClientJsonpModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    OrderByPipe,
    FilterPipe,
    TooltipListPipe,
    ConvertUnitsPipe,
    SafePipe,
    MonthYearValidatorDirective,
    DayMonthYearValidatorDirective,
    KeysPipe,
    StarRatingComponent,
    IconsComponent,
    NotFoundComponent,
  ],
  bootstrap: []
})
export class AppCommonModule {}
